// extracted by mini-css-extract-plugin
export default {"location":"Location_location__-5HxP"};